import React from 'react';
import {Container} from 'react-bootstrap';
import PropTypes from 'prop-types';
import NavPublic from '../Nav/Public';

const LayoutPublic = (props) => {
	const {children} = props;

	return (
		<>
			<NavPublic />
			<Container style={{marginTop: '3rem'}}>
				{children}
			</Container>
		</>
	);
};

LayoutPublic.propTypes = {
	children: PropTypes.node.isRequired
};

export default LayoutPublic;
